import axios from 'axios';

const baseEndpoint = 'v1/chat';

const ChatService = {
  formatFormDataBody( data ) {
    const formData = new FormData();

    _.forEach( data, ( value, key ) => {
      if( value ) formData.append( key, value );
    } );

    return formData;
  },

  login() {
    return axios
      .post( 'oauth/v2/token', {
        client_id: '7_2bisq4487vy88gog800040c0cskc4o8ckgsc0gw0kc088gk0go',
        client_secret: '2c03vskuj2hwc4ow88k80ssogg4ocs4044osg8008s8cc4o4w8',
        grant_type: 'client_credentials'
      } )
  },

  registerChannel( token, data ) {
    return axios
      .post( `${baseEndpoint}/register-channel`, data )
  },

  getOperatorCredentials() {
    return axios
      .get( `${baseEndpoint}/operator-credential` )
  },

  getMessages( params ) {
    return axios
      .get( `${baseEndpoint}/messages`, { params } )
  },

  sendFile( data ) {
    return axios
      .post( `${baseEndpoint}/message`, this.formatFormDataBody( data ) )
  },
};

export default ChatService;



// WEBPACK FOOTER //
// ./services/ChatService.js